// Pastilles « du nouveau » dans le menu (04/10/2026) : nombres recalculés toutes les minutes (et au retour sur
// l'onglet), jamais bloquants. Les API sont chargées à la demande pour ne pas alourdir le menu.

export const INTERVALLE_BADGES = 60000

// Transferts en route (patients à accueillir) : médecin et infirmier.
export async function compterTransferts() {
    const api = (await import('@/api/consultations/_parcours')).default
    const reponse = await api.patientsPresents(false)
    const lignes = reponse && Array.isArray(reponse.data) ? reponse.data : []
    return lignes.filter(ligne => ligne && ligne.transfert_en_cours).length
}

// Soins en retard ou à faire maintenant : infirmier.
export async function compterSoins() {
    const api = (await import('@/api/_infirmier')).default
    const reponse = await api.getSoinsAFaire({ page: 1, per_page: 1 })
    const compteurs = (reponse && reponse.counts) || {}
    return (Number(compteurs.en_retard) || 0) + (Number(compteurs.maintenant) || 0)
}

export const BADGES_PAR_ROLE = {
    ROLE_MEDECIN: { parcours: compterTransferts },
    ROLE_INFIRMIER: { parcours: compterTransferts, soins: compterSoins },
}

// Calcule les pastilles du rôle ; une erreur laisse simplement la pastille précédente.
export async function calculerBadges(role, precedents, sources) {
    const liste = (sources || BADGES_PAR_ROLE)[role] || {}
    const resultat = Object.assign({}, precedents || {})
    await Promise.all(Object.keys(liste).map(async cle => {
        try { resultat[cle] = await liste[cle]() } catch (erreur) { /* pastille inchangée */ }
    }))
    return resultat
}

export function libelleBadge(nombre) {
    return nombre > 99 ? '99+' : String(nombre)
}

// Son joué quand la pastille augmente (04/10/2026) ; voir @/utils/sons-alertes.
export const SON_DU_BADGE = { parcours: 'transferts', soins: 'soins' }

export function alertesDuRole(role) {
    return Object.keys(BADGES_PAR_ROLE[role] || {}).map(cle => SON_DU_BADGE[cle]).filter(Boolean)
}
